export const ApiServices = {
  GET_PAGE_BY_TYPE_DATA: '/get-req-data/page-by-type/',
  GET_CHILD_BY_PAGE_ID: '/get-req-data/child-pages/',
  GET_PAGE_BY_PAGE_SLUG: '/get-req-data/page-by-slug/',
  GET_FORM_FIELDS: '/get-req-data/form-fields',
  POST_FORM_SUBMIT: '/post-req-data/form-submit'
}
